export default "/images/vendor/flag-icons/flags/1x1/np.svg?a0599715685449f39364d19a223a99c6";